import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Input,
  Table,
  Tag,
  Button,
  message,
  Form,
  Row,
  DatePicker,
  Col,
  Modal,
  Card,
  Radio,
} from "antd";
import Service from "../../../service";
import moment from "moment";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { showAuthLoader, hideAuthLoader } from "../../../appRedux/actions/Auth";
import { getResource } from "../../../util/getResourcePermission";
import config from "../../../permission/config.json"
import AddWfhRequestModal from "./AddWfhRequest";
import { ArrowLeftOutlined, PlusOutlined } from "@ant-design/icons";
import "../../../assets/css/master-table.css";
const Search = Input.Search;

const Wfhlisting = (props) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [IsModalView, setIsModalView] = useState(false);
  const [seachEnabled, setSearchEnabled] = useState(false);
  const [val, setVal] = useState("All");
  let [filterData, setFilterData] = useState([]);
  const searchRef = useRef();
  const [empData, setEmpData] = useState([]);
  const [employeeData, setEmployeeData] = useState({})
  const [isWFHModalOpen, setisWFHModalOpen] = useState(false);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
  });
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  let { authUser } = useSelector(({ auth }) => auth);

  useEffect(() => {
    getEmployeesLeaveList();
  }, [filterData, searchText, pagination.current, pagination.pageSize]);

  const getEmployeesLeaveList = useCallback(async () => {
    try {
      dispatch(showAuthLoader());
      const reqBody = {
        emp_code: authUser?.emp_code,
        pageNum: pagination.current,
        pageLimit: pagination.pageSize,
        // application_to_date: filterData?.application_to_date
        //   ? moment(filterData?.application_to_date).format("YYYY-MM-DD")
        //   : moment().format("YYYY-MM-DD"),
        // to_date: moment(filterData?.leave_from_date).format("YYYY-MM-DD")
        //   ? moment()
        //   : filterData?.leave_to_date,
        status: "All",
      };
      if (searchText && searchText !== "") {
        reqBody.search = searchText;
        setSearchEnabled(true);
      }
      if (filterData) {
        if (filterData?.status) {
          reqBody.status = filterData.status;
        }
        if (filterData?.application_from_date) {
          reqBody.application_from_date = moment(
            filterData.application_from_date
          ).format("YYYY-MM-DD");
        }
        if (filterData?.application_to_date) {
          reqBody.application_to_date = moment(
            filterData.application_to_date
          ).format("YYYY-MM-DD");
        }
        if (filterData?.from_date) {
          reqBody.from_date = moment(filterData.from_date).format("YYYY-MM-DD");
        }
        if (filterData?.to_date) {
          reqBody.to_date = moment(filterData.to_date).format("YYYY-MM-DD");
        }
      }

      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.wfhlisting,
        body: reqBody,
      });

      dispatch(hideAuthLoader());
      if (response?.data?.data?.length > 0) {
        if (filterData?.isActive == true) {
          setPagination({
            ...pagination,
            total: response.data.metaData.totalFilteredCount,
            deactivetotal: response.data.metaData.totaldUsers,
          });
        } else {
          setPagination({
            ...pagination,
            total: response.data.metaData.totalFilteredCount,
            // deactivetotal: response.data.metaData.totaldsUsers,
          });
        }

        const employee = response.data.data;
        employee?.map((val, index) => (val["key"] = val?._id));
        setEmpData([]);
        setEmpData(employee);
      } else {
        setPagination({
          ...pagination,
          total: 0,
        });
        setEmpData([]);
        // message.error(response.data.message);
      }
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
    }
  }, [filterData, searchText, pagination.current, pagination.pageSize]);

  const filterEmp = async (values) => {
    if (
      (values.application_from_date &&
        values.application_to_date == undefined) ||
      "" ||
      null
    ) {
      message.error("Please select Application To date");
      return;
    }
    if (
      (values.application_to_date &&
        values.application_from_date == undefined) ||
      "" ||
      null
    ) {
      message.error("Please select Application from date");
      return;
    }

    if ((values.from_date && values.to_date == undefined) || "" || null) {
      message.error("Please select WFH to date");
      return;
    }
    if ((values.to_date && values.from_date == undefined) || "" || null) {
      message.error("Please select WFH from date");
      return;
    }
    setFilterData(values);
    setIsModalView(!IsModalView);
  };

  const getFooterDetails = () => {
    return (
      <label>
        Total Records Count is { pagination.total > 0 ? pagination.total : 0 }
      </label>
    );
  };

  const handleTableChange = (page, filters, sorter) => {
    setPagination({ ...pagination, ...page });
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const openEventModalView = () => {
    // setEvent_record(record);
    setIsModalView(true);
  };
  const closeEventModalView = () => {
    // setEvent_record(record);
    form.resetFields();
    setIsModalView(!IsModalView);
    // setFilterData([]);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };

  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 16,
        offset: 8,
      },
    },
  };

  const onSearch = (value) => {
    setSearchText(value);
    setPagination({ ...pagination, current: 1 });
  };

  const resetSearchFilter = (e) => {
    const keyCode = e && e.keyCode ? e.keyCode : e;
    switch (keyCode) {
      case 8:
        if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
          searchRef.current.state.value = "";
          setSearchText("");
          setSearchEnabled(false);
        }
        break;
      case 46:
        if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
          searchRef.current.state.value = "";
          setSearchText("");
          setSearchEnabled(false);
        }
        break;
      default:
        break;
    }
  };

  const columns = [
    {
      title: "Application Date",
      dataIndex: "application_date",
      key: "application_date",
      render: (text, record, index) => {
        const event_name = record?.application_date
          ? moment(record.application_date).format("DD-MMM-YYYY")
          : "-";
        return (
          // <Link type="button" to={`/event/event-view/${record._id}`}>

          <span
            className={
              record?.application_date ? "ema-cell-date" : "ema-cell-muted"
            }
          >
            { event_name }
          </span>
          // </Link>
        );
      },
    },
    {
      title: val != "Rejected" ? "Approval Date" : "Rejected Date",
      dataIndex: "leave_approval_date",
      key: "leave_approval_date",
      render: (text, record, index) => {
        const adate = record?.WFH_approval_date
          ? moment(record?.WFH_approval_date).format("DD-MMM-YYYY")
          : "-";
        const adate2 = record?.WFH_rejected_date
          ? moment(record?.WFH_rejected_date).format("DD-MMM-YYYY")
          : "-";
        const shown = val != "Rejected" ? adate : adate2;
        return (
          <span className={ shown === "-" ? "ema-cell-muted" : "ema-cell-date" }>
            { shown }
          </span>
        );
      },
    },

    {
      title: "Manager",
      dataIndex: "reporting_manager",
      key: "reporting_manager",
      render: (text, record, index) => {
        const adate = record?.reporting_manager;

        return adate ? (
          <span className="ema-cell-capitalize">{ adate }</span>
        ) : (
          <span className="ema-cell-muted">-</span>
        );
      },
    },
    {
      title: "From Date",
      dataIndex: "from_date",
      key: "from_date",
      render: (text, record, index) => {
        let adate = moment(record?.from_date).format("DD-MMM-YYYY");
        return <span className="ema-cell-date">{ adate }</span>;
      },
    },
    {
      title: "No of Days",
      dataIndex: "no_of_days",
      key: "no_of_days",
      render: (text, record, index) => {
        let adate = record?.no_of_days;

        return <span>{ adate }</span>;
      },
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      render: (text, record, index) => {
        let adate = record?.reason;
        return (
          <>
            <span>{ adate?.substring(0, 50) }</span>
            <br />
            <span>{ adate?.substring(50) }</span>
          </>
        );
      },
    },
    {
      title: "Approved",
      dataIndex: "status",
      key: "status",
      render: (text, record, index) => {
        if (record?.status == "Accepted") {
          const approved_by = record?.is_auto_approved
            ? "Automatically"
            : "By Manager";
          return approved_by ? <span>{ approved_by }</span> : null;
        } else {
          return <span className="ema-cell-muted">-</span>;
        }
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "leave_status",
      render: (text, record, index) => {
        const position = record?.status;

        const color =
          record?.status == "Pending"
            ? "processing"
            : record?.status == "Accepted"
              ? "success"
              : "error";

        return position ? <Tag color={ color }>{ position }</Tag> : null;
      },
    },
  ];

  const fetchEmployeeDetails = async () => {
    try {
      dispatch(showAuthLoader());
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.empById + `/${authUser._id}`
      });
      if (response?.data && response.data.status === 200) {
        const empData = response?.data?.data
        // console.log(empData,'empData');

        setEmployeeData(empData)
      } else {
        message.error(response.data.message)
      }
      dispatch(hideAuthLoader());
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
    }
  };
  useEffect(() => { fetchEmployeeDetails() }, [])
  return (
    <>

      <Card className="employee-card" >
        <div className="inout-header text-left">
          <div className="title">
            <h2> Work From Home Applications </h2>
          </div>
          <div className="header-btns">

            {
              getResource(config.RESOURCES.WHF_APPLICATIONS, ["create"]) && employeeData?.wfh_applicable && (

                <Button
                  type="primary"
                  icon={ <PlusOutlined /> }
                  className="addleave-btn"
                  onClick={ () => setisWFHModalOpen(true) }
                  disabled={ employeeData.emp_type == "Probation" ||
                    (employeeData.left_date !== null && employeeData.emp_last_working_date !== null) }

                >
                  Add WFH Application
                </Button>
              )
            }
            <Link to="/leave-application">
              <Button type="primary" icon={ <ArrowLeftOutlined /> } style={ { marginLeft: "5px" } }>
                Back
              </Button></Link>

          </div>
        </div>
        <Card className="main-content-wrapper" >

          <div className="search-wrapper">
            <Search
              ref={ searchRef }
              placeholder="Search..."
              onSearch={ onSearch }
              onKeyUp={ resetSearchFilter }
              style={ { width: 200 } }
              className=""
            />
            <div className="filter-btns-wrapper">

              <Button
                onClick={ () => openEventModalView() }
                className="filter-btn"
                type="primary"
              >
                Filter
              </Button>
              <Button
                onClick={ () => {
                  form.resetFields();
                  setFilterData([]);
                  setVal("All");
                } }
                className=" delete-btn"
                disabled={ filterData.length != 0 ? false : true }
              >
                Reset
              </Button>
            </div>
          </div>

          <Modal
            title="Filter"
            width={ 800 }
            visible={ IsModalView }
            onCancel={ closeEventModalView }
            footer={ [
              <Button key="cancel" className="delete-btn" onClick={ closeEventModalView }>
                Cancel
              </Button>,
              <Button
                key="clear"
                className="delete-btn"
                onClick={ () => {
                  form.resetFields();
                  setFilterData([]);
                } }
              >
                Reset
              </Button>,
              <Button key="submit" type="primary" htmlType="submit" onClick={ () => form.submit() }>
                Apply
              </Button>,
            ] }
          >
            <Form form={ form } layout="vertical" onFinish={ filterEmp }>
              <div className="main-form-wrapper">
                <div className="form-container">
                  <div className="form-row">
                    <div className="form-col">
                      <div className="form-item">
                        <Form.Item
                          label="Application From Date"
                          name="application_from_date"
                          onChange={
                            form.getFieldValue("application_to_date") == undefined ||
                              "" ||
                              null
                              ? () =>
                                form.setFieldsValue({
                                  application_to_date: filterData?.application_from_date,
                                })
                              : () => { }
                          }
                        >
                          <DatePicker format="DD-MM-YYYY" className="fulldate-width" />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="form-col">
                      <div className="form-item">
                        <Form.Item
                          label="WFH From Date"
                          name="from_date"
                          onChange={
                            form.getFieldValue("leave_to_date") == undefined ||
                              "" ||
                              null
                              ? () =>
                                form.setFieldsValue({
                                  leave_to_date: filterData?.leave_from_date,
                                })
                              : () => { }
                          }
                        >
                          <DatePicker format="DD-MM-YYYY" className="fulldate-width" />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-col">
                      <div className="form-item">
                        <Form.Item label="Application To Date" name="application_to_date">
                          <DatePicker
                            format="DD-MM-YYYY"
                            className="fulldate-width"
                            disabledDate={ (value) => {
                              return value < form.getFieldValue("application_from_date");
                            } }
                          />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="form-col">
                      <div className="form-item">
                        <Form.Item label="WFH To Date" name="to_date">
                          <DatePicker
                            format="DD-MM-YYYY"
                            className="fulldate-width"
                            disabledDate={ (value) => {
                              return value < form.getFieldValue("from_date");
                            } }
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-col-full">
                      <div className="form-item">
                        <Form.Item name="status" initialValue="All">
                          <Radio.Group
                            name="radiogroup"
                            onChange={ (e) => {
                              setVal(e.target.value);
                            } }
                          >
                            <Radio value="All">All</Radio>
                            <Radio value="Pending">Pending</Radio>
                            <Radio value="Accepted">Approved</Radio>
                            <Radio value="Rejected">Rejected</Radio>
                          </Radio.Group>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </Modal>
          <div className="main-table-wrapper">

            <Table
              className="hrms-master-table"
              columns={ columns }
              pagination={ {
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "30"],
                ...pagination,
              } }
              // rowSelection={rowSelection}
              footer={ getFooterDetails }
              onChange={ handleTableChange }
              dataSource={ empData }
            />
          </div>
        </Card>
      </Card>

      <AddWfhRequestModal
        show={ isWFHModalOpen }
        onClose={ () => setisWFHModalOpen(false) }
        onSuccess={ () => {
          setisWFHModalOpen(false);
          getEmployeesLeaveList();
        } }
      />
    </>
  );
};

export default Wfhlisting;
